import React from 'react';
import { Navbar } from '../supervisor/vertialmenu/NavBar';
import { NavBarProfile } from '../supervisor/navBarPorfile/navBarProfile';

const MainLayout = ({ children }) => {
  return (
    <div style={{ display: "flex", overflowX: "hidden" }}>
      <Navbar />
      <div style={{
        backgroundColor: "#F3F3F3",
        width: "100%",
        maxHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}>
        <NavBarProfile />
        <div className="main-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;